import React, { useCallback } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_AGENT_ADD } from 'ducks/drawers/types'

const AddUserDrawerLink = ({ highlight }) => {
  const { openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_AGENT_ADD,
    lazyLoad: true,
  })

  const onOpen = useCallback(
    () => {
      openAddDrawer('new', { additionalProps: { title: 'Add User' } })
    },
    [openAddDrawer]
  )

  return (
    <div className={cn('item clickable agent', { highlight })}>
      <a className="name" onClick={onOpen}>
        + Add team member
      </a>
    </div>
  )
}

AddUserDrawerLink.propTypes = {
  highlight: PropTypes.bool,
}

AddUserDrawerLink.defaultProps = {
  highlight: false,
}

export default AddUserDrawerLink
